import axios from '@/plugins/axios';
import utils from '@/stores/utils';

const state = {
    establishments: [],
    establishments_filters: { offset: 0, limit: 20, ordering: '-main,name' },
    establishments_count: 0,
    establishments_loaded: false,
    establishments_loading: false,
    establishments_loading_errors: null,
    establishment_deleting: false,
};

const mutations = {
    updateEstablishments(state, establishments) {
        state.establishments = establishments;
        state.establishments_loaded = true;
    },
    updateEstablishmentsFilters(state, establishments_filters) {
        state.establishments_filters = establishments_filters;
    },
    updateEstablishmentsCount(state, establishments_count) {
        state.establishments_count = establishments_count;
    },
    updateEstablishmentsLoading(state, loading) {
        state.establishments_loading = loading;
        if (loading) {
            state.establishments_loaded = false;
        }
    },
    updateEstablishmentsLoadingErrors(state, errors) {
        state.establishments_loading_errors = errors;
    },
    updateEstablishmentDeleting(state, deleting) {
        state.establishment_deleting = deleting;
    },
};

const actions = {

    async setEstablishmentAsMain({ commit, dispatch }, params) {
        const url = `/api/establishments/${params.instance.id}/setasmain/`;
        try {
            const response = await axios.post(url);
            await dispatch('fetchEstablishments');
            dispatch('session/fetchStats', null, { root: true });
            return response;
        } catch (xhr_error) {
            const error = utils.handleError(xhr_error);
            throw error;
        }
    },

    async deleteEstablishment({ commit, dispatch, state }, params) {
        commit('updateEstablishmentDeleting', true);

        const url = `/api/establishments/${params.instance.id}/archive/`;
        try {
            const response = await axios.post(url);
            commit('updateEstablishmentDeleting', false);
            return response;
        } catch (xhr_error) {
            const error = utils.handleError(xhr_error);
            commit('updateEstablishmentDeleting', false);
            throw error;
        } finally {
            dispatch('fetchEstablishments');
            dispatch('session/fetchStats', null, { root: true });
        }
    },

    async unarchiveEstablishment({ commit, dispatch }, params) {
        const url = `/api/establishments/${params.instance.id}/unarchive/`;
        try {
            const response = await axios.post(url);
            return response;
        } catch (xhr_error) {
            throw utils.handleError(xhr_error);
        } finally {
            dispatch('fetchEstablishments');
            dispatch('session/fetchStats', null, { root: true });
        }
    },

    async fetchEstablishments({ commit, dispatch, state }, params) {
        commit('updateEstablishmentsLoading', true);
        commit('updateEstablishmentsLoadingErrors', null);

        try {
            const response = await axios.get('/api/establishments/', {
                params: state.establishments_filters,
            });
            commit('updateEstablishmentsLoading', false);
            commit('updateEstablishments', response.data.results);
            commit('updateEstablishmentsCount', response.data.count);
            return response;
        } catch (xhr_error) {
            let error = utils.handleError(xhr_error);
            commit('updateEstablishmentsLoadingErrors', error.details);
            commit('updateEstablishmentsLoading', false);
            throw error;
        }
    },

};

export default {
    namespaced: true,
    state,
    actions,
    mutations,
};

